import request from 'superagent';

export const setUserFlagAction = (context, { flag }) => {
    context.dispatch('ACTIVE_USER_FLAG_SET', { flag });

    const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
    request
        .post('/user/xhr/flags')
        .type('form')
        .send({ flag: flag })
        .set('X-Csrf-Token', csrfToken)
        .end((err, res) => {
            if (err) {
                throw new Error('Problem setting user flag:' + err);
            }
        });
};



// WEBPACK FOOTER //
// ./src/web/js/contest/actions/set-user-flag.js